import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage'
import { Box, Title } from '@mantine/core'
import React from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreLocale, type ESystemLanguage } from '@flecto/types'
import { Badge, CollapsibleCard } from '@flecto/ui'
import { SelectLocale } from '@flecto/ui/@shared/SelectLocale'
import { useLocaleName } from '@flecto/utils/src/Hooks/useLocaleName'

import { useFormContext } from './FormCustomer'

export function Language() {
  const { t, i18n } = useTranslation('saas', { keyPrefix: 'customers' })
  const form = useFormContext()

  const [locale, setLocale] = React.useState<ESystemLanguage>(
    form.getInputProps('locale').value || i18n.language
  )
  const localeName = useLocaleName(locale)

  return (
    <Box mb='lg'>
      <Title order={4} mb='md'>
        {t('title_other_settings')}
      </Title>
      <CollapsibleCard>
        <CollapsibleCard.Title>
          {t('add_customer.language')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          {t('add_customer.language_description')}
        </CollapsibleCard.Description>
        <CollapsibleCard.Icon withCircleBackground icon={faLanguage} />
        <CollapsibleCard.RightSection>
          <Badge color='gray'>{localeName}</Badge>
        </CollapsibleCard.RightSection>
        <CollapsibleCard.Content>
          <SelectLocale
            w={250}
            mb='xs'
            label={t('add_customer.language')}
            onChange={(value) => {
              setLocale(value as ESystemLanguage)
              form.setFieldValue('locale', value as CoreLocale)
            }}
            defaultValue={locale}
          />
        </CollapsibleCard.Content>
      </CollapsibleCard>
    </Box>
  )
}
